// Comprehensive sports data for dropdowns
// This data can be seeded/updated from the OpticOdds API

export const sportsData = {
    'Basketball': {
        leagues: ['NBA', 'WNBA', 'NCAAB', 'G League', 'EuroLeague'],
        apiLeagues: { 'NBA': 'nba', 'WNBA': 'wnba', 'NCAAB': 'ncaab', 'G League': 'nba_g_league', 'EuroLeague': 'euroleague' },
        sport: 'basketball',
        teams: {
            'NBA': [
                // Eastern Conference - Atlantic
                'Boston Celtics', 'Brooklyn Nets', 'New York Knicks', 'Philadelphia 76ers', 'Toronto Raptors',
                // Eastern Conference - Central
                'Chicago Bulls', 'Cleveland Cavaliers', 'Detroit Pistons', 'Indiana Pacers', 'Milwaukee Bucks',
                // Eastern Conference - Southeast
                'Atlanta Hawks', 'Charlotte Hornets', 'Miami Heat', 'Orlando Magic', 'Washington Wizards',
                // Western Conference - Northwest
                'Denver Nuggets', 'Minnesota Timberwolves', 'Oklahoma City Thunder', 'Portland Trail Blazers', 'Utah Jazz',
                // Western Conference - Pacific
                'Golden State Warriors', 'LA Clippers', 'Los Angeles Lakers', 'Phoenix Suns', 'Sacramento Kings',
                // Western Conference - Southwest
                'Dallas Mavericks', 'Houston Rockets', 'Memphis Grizzlies', 'New Orleans Pelicans', 'San Antonio Spurs'
            ],
            'WNBA': [
                'Atlanta Dream', 'Chicago Sky', 'Connecticut Sun', 'Dallas Wings', 'Indiana Fever',
                'Las Vegas Aces', 'Los Angeles Sparks', 'Minnesota Lynx', 'New York Liberty', 'Phoenix Mercury',
                'Seattle Storm', 'Washington Mystics'
            ],
            'NCAAB': [
                // ACC
                'Duke Blue Devils', 'North Carolina Tar Heels', 'Virginia Cavaliers', 'Miami Hurricanes', 'Florida State Seminoles',
                'Louisville Cardinals', 'Syracuse Orange', 'NC State Wolfpack', 'Wake Forest Demon Deacons', 'Clemson Tigers',
                'Boston College Eagles', 'Georgia Tech Yellow Jackets', 'Notre Dame Fighting Irish', 'Pittsburgh Panthers', 'Virginia Tech Hokies',
                // Big Ten
                'Michigan Wolverines', 'Michigan State Spartans', 'Ohio State Buckeyes', 'Indiana Hoosiers', 'Purdue Boilermakers',
                'Illinois Fighting Illini', 'Wisconsin Badgers', 'Iowa Hawkeyes', 'Minnesota Golden Gophers', 'Penn State Nittany Lions',
                'Maryland Terrapins', 'Northwestern Wildcats', 'Rutgers Scarlet Knights', 'Nebraska Cornhuskers',
                // Big 12
                'Kansas Jayhawks', 'Baylor Bears', 'Texas Tech Red Raiders', 'Iowa State Cyclones', 'Oklahoma State Cowboys',
                'Texas Longhorns', 'TCU Horned Frogs', 'West Virginia Mountaineers', 'Kansas State Wildcats', 'Oklahoma Sooners',
                'BYU Cougars', 'Cincinnati Bearcats', 'Houston Cougars', 'UCF Knights',
                // SEC
                'Kentucky Wildcats', 'Tennessee Volunteers', 'Auburn Tigers', 'Alabama Crimson Tide', 'Arkansas Razorbacks',
                'LSU Tigers', 'Florida Gators', 'Texas A&M Aggies', 'Missouri Tigers', 'Mississippi State Bulldogs',
                'Ole Miss Rebels', 'Georgia Bulldogs', 'South Carolina Gamecocks', 'Vanderbilt Commodores',
                // Pac-12
                'UCLA Bruins', 'Arizona Wildcats', 'Oregon Ducks', 'USC Trojans', 'Arizona State Sun Devils',
                'Colorado Buffaloes', 'Utah Utes', 'Washington Huskies', 'Stanford Cardinal', 'California Golden Bears',
                'Oregon State Beavers', 'Washington State Cougars',
                // Big East
                'UConn Huskies', 'Villanova Wildcats', 'Creighton Bluejays', 'Marquette Golden Eagles', 'Xavier Musketeers',
                'Providence Friars', 'Seton Hall Pirates', 'St. Johns Red Storm', 'Georgetown Hoyas', 'Butler Bulldogs', 'DePaul Blue Demons',
                // Other Notable
                'Gonzaga Bulldogs', 'Memphis Tigers', 'San Diego State Aztecs', 'Saint Marys Gaels', 'Nevada Wolf Pack'
            ]
        },
        markets: {
            game: ['Moneyline', 'Point Spread', 'Total Points', '1st Half Moneyline', '1st Half Spread', '1st Half Total', 
                   '1st Quarter Moneyline', '1st Quarter Spread', '1st Quarter Total', 'Team Total', 'Alternate Spread', 'Alternate Total'],
            player: ['Player Points', 'Player Rebounds', 'Player Assists', 'Player Points + Rebounds', 'Player Points + Assists',
                     'Player Rebounds + Assists', 'Player Points + Rebounds + Assists', 'Player Steals', 'Player Blocks',
                     'Player Made Threes', 'Player Double Double', 'Player Triple Double', 'Player Turnovers']
        }
    },
    'Football': {
        leagues: ['NFL', 'NCAAF', 'CFL', 'XFL'],
        apiLeagues: { 'NFL': 'nfl', 'NCAAF': 'ncaaf', 'CFL': 'cfl', 'XFL': 'xfl' },
        sport: 'football',
        teams: {
            'NFL': [
                // AFC East
                'Buffalo Bills', 'Miami Dolphins', 'New England Patriots', 'New York Jets',
                // AFC North
                'Baltimore Ravens', 'Cincinnati Bengals', 'Cleveland Browns', 'Pittsburgh Steelers',
                // AFC South
                'Houston Texans', 'Indianapolis Colts', 'Jacksonville Jaguars', 'Tennessee Titans',
                // AFC West
                'Denver Broncos', 'Kansas City Chiefs', 'Las Vegas Raiders', 'Los Angeles Chargers',
                // NFC East
                'Dallas Cowboys', 'New York Giants', 'Philadelphia Eagles', 'Washington Commanders',
                // NFC North
                'Chicago Bears', 'Detroit Lions', 'Green Bay Packers', 'Minnesota Vikings',
                // NFC South
                'Atlanta Falcons', 'Carolina Panthers', 'New Orleans Saints', 'Tampa Bay Buccaneers',
                // NFC West
                'Arizona Cardinals', 'Los Angeles Rams', 'San Francisco 49ers', 'Seattle Seahawks'
            ],
            'NCAAF': [
                // SEC
                'Alabama Crimson Tide', 'Georgia Bulldogs', 'LSU Tigers', 'Tennessee Volunteers', 'Texas A&M Aggies',
                'Florida Gators', 'Auburn Tigers', 'Ole Miss Rebels', 'Arkansas Razorbacks', 'Kentucky Wildcats',
                'South Carolina Gamecocks', 'Missouri Tigers', 'Mississippi State Bulldogs', 'Vanderbilt Commodores',
                // Big Ten
                'Michigan Wolverines', 'Ohio State Buckeyes', 'Penn State Nittany Lions', 'Wisconsin Badgers', 'Iowa Hawkeyes',
                'Michigan State Spartans', 'Minnesota Golden Gophers', 'Illinois Fighting Illini', 'Northwestern Wildcats',
                'Nebraska Cornhuskers', 'Purdue Boilermakers', 'Indiana Hoosiers', 'Maryland Terrapins', 'Rutgers Scarlet Knights',
                // ACC
                'Clemson Tigers', 'Florida State Seminoles', 'Miami Hurricanes', 'North Carolina Tar Heels', 'NC State Wolfpack',
                'Duke Blue Devils', 'Pittsburgh Panthers', 'Louisville Cardinals', 'Wake Forest Demon Deacons', 'Syracuse Orange',
                'Virginia Cavaliers', 'Virginia Tech Hokies', 'Boston College Eagles', 'Georgia Tech Yellow Jackets',
                // Big 12
                'Texas Longhorns', 'Oklahoma Sooners', 'TCU Horned Frogs', 'Kansas State Wildcats', 'Oklahoma State Cowboys',
                'Baylor Bears', 'Iowa State Cyclones', 'Kansas Jayhawks', 'West Virginia Mountaineers', 'Texas Tech Red Raiders',
                // Pac-12
                'USC Trojans', 'Oregon Ducks', 'Washington Huskies', 'Utah Utes', 'UCLA Bruins', 'Oregon State Beavers',
                'Arizona Wildcats', 'Arizona State Sun Devils', 'Stanford Cardinal', 'California Golden Bears',
                'Colorado Buffaloes', 'Washington State Cougars',
                // Other Notable
                'Notre Dame Fighting Irish', 'BYU Cougars', 'UCF Knights', 'Cincinnati Bearcats', 'Houston Cougars'
            ]
        },
        markets: {
            game: ['Moneyline', 'Point Spread', 'Total Points', '1st Half Moneyline', '1st Half Spread', '1st Half Total',
                   '1st Quarter Spread', '1st Quarter Total', 'Team Total', 'Alternate Spread', 'Alternate Total'],
            player: ['Player Passing Yards', 'Player Passing TDs', 'Player Rushing Yards', 'Player Rushing TDs', 
                     'Player Receiving Yards', 'Player Receptions', 'Anytime Touchdown', 'First Touchdown',
                     'Player Passing Attempts', 'Player Completions', 'Player Interceptions']
        }
    },
    'Baseball': {
        leagues: ['MLB'],
        apiLeagues: { 'MLB': 'mlb' },
        sport: 'baseball',
        teams: {
            'MLB': [
                // AL East
                'Baltimore Orioles', 'Boston Red Sox', 'New York Yankees', 'Tampa Bay Rays', 'Toronto Blue Jays',
                // AL Central
                'Chicago White Sox', 'Cleveland Guardians', 'Detroit Tigers', 'Kansas City Royals', 'Minnesota Twins',
                // AL West
                'Houston Astros', 'Los Angeles Angels', 'Oakland Athletics', 'Seattle Mariners', 'Texas Rangers',
                // NL East
                'Atlanta Braves', 'Miami Marlins', 'New York Mets', 'Philadelphia Phillies', 'Washington Nationals',
                // NL Central
                'Chicago Cubs', 'Cincinnati Reds', 'Milwaukee Brewers', 'Pittsburgh Pirates', 'St. Louis Cardinals',
                // NL West
                'Arizona Diamondbacks', 'Colorado Rockies', 'Los Angeles Dodgers', 'San Diego Padres', 'San Francisco Giants'
            ]
        },
        markets: {
            game: ['Moneyline', 'Run Line', 'Total Runs', '1st 5 Innings Moneyline', '1st 5 Innings Run Line', 
                   '1st 5 Innings Total', '1st Inning Result', 'Team Total', 'Alternate Run Line', 'Alternate Total'],
            player: ['Player Hits', 'Player Home Runs', 'Player RBIs', 'Player Total Bases', 'Player Runs Scored',
                     'Pitcher Strikeouts', 'Player Stolen Bases', 'Player Walks']
        }
    },
    'Hockey': {
        leagues: ['NHL'],
        apiLeagues: { 'NHL': 'nhl' },
        sport: 'hockey',
        teams: {
            'NHL': [
                // Atlantic
                'Boston Bruins', 'Buffalo Sabres', 'Detroit Red Wings', 'Florida Panthers', 'Montreal Canadiens', 
                'Ottawa Senators', 'Tampa Bay Lightning', 'Toronto Maple Leafs',
                // Metropolitan
                'Carolina Hurricanes', 'Columbus Blue Jackets', 'New Jersey Devils', 'New York Islanders', 
                'New York Rangers', 'Philadelphia Flyers', 'Pittsburgh Penguins', 'Washington Capitals',
                // Central
                'Arizona Coyotes', 'Chicago Blackhawks', 'Colorado Avalanche', 'Dallas Stars', 'Minnesota Wild', 
                'Nashville Predators', 'St. Louis Blues', 'Winnipeg Jets',
                // Pacific
                'Anaheim Ducks', 'Calgary Flames', 'Edmonton Oilers', 'Los Angeles Kings', 'San Jose Sharks', 
                'Seattle Kraken', 'Vancouver Canucks', 'Vegas Golden Knights'
            ]
        },
        markets: {
            game: ['Moneyline', 'Puck Line', 'Total Goals', '1st Period Moneyline', '1st Period Puck Line', 
                   '1st Period Total', 'Team Total', 'Regulation Time Result', '60 Minute Line'],
            player: ['Player Goals', 'Player Assists', 'Player Points', 'Player Shots on Goal', 'Player Saves',
                     'Anytime Goalscorer', 'First Goalscorer', 'Player Blocked Shots']
        }
    },
    'Soccer': {
        leagues: ['MLS', 'Premier League', 'La Liga', 'Serie A', 'Bundesliga', 'Ligue 1', 'Champions League'],
        apiLeagues: { 
            'MLS': 'mls', 'Premier League': 'epl', 'La Liga': 'laliga', 'Serie A': 'serie_a', 
            'Bundesliga': 'bundesliga', 'Ligue 1': 'ligue_1', 'Champions League': 'ucl' 
        },
        sport: 'soccer',
        teams: {
            'MLS': [
                'Atlanta United', 'Austin FC', 'Charlotte FC', 'Chicago Fire', 'FC Cincinnati', 'Colorado Rapids',
                'Columbus Crew', 'DC United', 'FC Dallas', 'Houston Dynamo', 'Inter Miami', 'LA Galaxy',
                'LAFC', 'Minnesota United', 'CF Montreal', 'Nashville SC', 'New England Revolution',
                'New York City FC', 'New York Red Bulls', 'Orlando City', 'Philadelphia Union', 'Portland Timbers',
                'Real Salt Lake', 'San Jose Earthquakes', 'Seattle Sounders', 'Sporting Kansas City', 'St. Louis City SC',
                'Toronto FC', 'Vancouver Whitecaps'
            ],
            'Premier League': [
                'Arsenal', 'Aston Villa', 'Bournemouth', 'Brentford', 'Brighton', 'Chelsea', 'Crystal Palace',
                'Everton', 'Fulham', 'Liverpool', 'Manchester City', 'Manchester United', 'Newcastle United',
                'Nottingham Forest', 'Tottenham', 'West Ham', 'Wolverhampton', 'Ipswich Town', 'Leicester City', 'Southampton'
            ]
        },
        markets: {
            game: ['Moneyline', 'Draw No Bet', 'Double Chance', 'Total Goals', 'Both Teams to Score', 
                   'Asian Handicap', 'Correct Score', '1st Half Result', '1st Half Total'],
            player: ['Player Goals', 'Player Assists', 'Player Shots', 'Anytime Goalscorer', 'First Goalscorer']
        }
    },
    'Tennis': {
        leagues: ['ATP', 'WTA'],
        apiLeagues: { 'ATP': 'atp', 'WTA': 'wta' },
        sport: 'tennis',
        teams: {},
        markets: {
            game: ['Moneyline', 'Set Spread', 'Total Sets', 'Total Games', '1st Set Winner', '1st Set Total Games'],
            player: ['Player Aces', 'Player Double Faults']
        }
    },
    'MMA': {
        leagues: ['UFC', 'Bellator', 'ONE Championship', 'PFL'],
        apiLeagues: { 'UFC': 'ufc', 'Bellator': 'bellator', 'ONE Championship': 'one_championship', 'PFL': 'pfl' },
        sport: 'mma',
        teams: {},
        markets: {
            game: ['Moneyline', 'Method of Victory', 'Round Betting', 'Total Rounds', 'Will the Fight Go the Distance?', 'Total Knockdowns'],
            player: []
        }
    },
    'Golf': {
        leagues: ['PGA Tour', 'DP World Tour', 'LIV Golf', 'LPGA'],
        apiLeagues: { 'PGA Tour': 'pga', 'DP World Tour': 'dp_world', 'LIV Golf': 'liv', 'LPGA': 'lpga' },
        sport: 'golf',
        teams: {},
        markets: {
            game: ['Tournament Winner', 'Top 5 Finish', 'Top 10 Finish', 'Top 20 Finish', 'Make/Miss Cut', 'Round Leader', 'Head to Head Match'],
            player: []
        }
    },
};

import _sharedSportsbooks from '../../utils/sportsbooks.json';

// Auto-generated from the backend's single source of truth (sportsbookData.js).
// To regenerate: node -e "const s=require('./functions/config/sportsbookData');require('fs').writeFileSync('./utils/sportsbooks.json',JSON.stringify(s.buildFrontendSportsbooks(),null,2))"
export const ALL_SPORTSBOOKS = _sharedSportsbooks;

// Legacy export for compatibility
export const SPORTSBOOKS = ALL_SPORTSBOOKS.filter(b => b.category === 'major').map(b => b.name);

// Helper to get display name from API id
export const getSportsbookName = (id) => {
  const book = ALL_SPORTSBOOKS.find(b => b.id === id || b.id === id.toLowerCase());
  if (book) return book.name;
  // Format API id to display name
  return id.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};

// Get books by category
export const getBooksByCategory = (category) => {
  return ALL_SPORTSBOOKS.filter(b => b.category === category);
};

// All category names
export const SPORTSBOOK_CATEGORIES = [
  { id: 'major', name: 'Major US Books', emoji: '🇺🇸' },
  { id: 'secondary', name: 'Other US Books', emoji: '📍' },
  { id: 'international', name: 'International', emoji: '🌍' },
  { id: 'dfs', name: 'DFS & Fantasy', emoji: '🎮' },
  { id: 'australia', name: 'Australia', emoji: '🇦🇺' },
  { id: 'exchange', name: 'Exchanges', emoji: '📊' },
  { id: 'canada', name: 'Canada', emoji: '🇨🇦' },
];

// Market categories for filtering
// Values are keyword arrays — any market name containing one of the keywords belongs to that category.
// Matching is case-insensitive substring, so 'player' catches all 100+ Player Props variants.
export const MARKET_CATEGORIES = {
    'All Markets': null,
    'Game Lines': ['moneyline', 'point spread', 'total points', 'total goals', 'total runs', 'run line', 'puck line', 'draw no bet', 'double chance', 'asian handicap', 'correct score', 'halftime / fulltime', 'both teams to score', 'asian total', 'goal spread', 'over/under'],
    'Player Props': ['player', 'anytime touchdown', 'anytime goalscorer', 'anytime scorer'],
    'Team Props': ['team total', 'team to score', 'team to win', 'team clean sheet', 'race to', 'first team to', 'last team to', 'both teams to score'],
    'Quarter / Half': ['quarter', '1st half', '2nd half', '3rd period', '1st period', '2nd period'],
};

// Time filters
export const TIME_FILTERS = [
    { label: 'All Games', value: null },
    { label: 'Today', value: 'today' },
    { label: 'Tomorrow', value: 'tomorrow' },
    { label: 'Next 24 Hours', value: 'next_24h' },
    { label: 'Next 48 Hours', value: 'next_48h' },
    { label: 'This Week', value: 'this_week' },
    { label: 'This Weekend', value: 'weekend' }
];

// Helper function to get teams for a specific sport/league
export const getTeams = (sport, league) => {
    if (!sport) return [];
    const sportData = sportsData[sport];
    if (!sportData || !sportData.teams) return [];
    // No league specified → return ALL teams for this sport across every league
    if (!league) return Object.values(sportData.teams).flat();
    return sportData.teams[league] || [];
};

// Helper function to get leagues for a specific sport
export const getLeagues = (sport) => {
    if (!sport) return [];
    const sportData = sportsData[sport];
    return sportData ? sportData.leagues : [];
};

// Helper function to get API league code
export const getApiLeague = (sport, league) => {
    if (!sport || !league) return null;
    const sportData = sportsData[sport];
    return sportData?.apiLeagues?.[league] || league.toLowerCase();
};

// Helper function to get sport code
export const getSportCode = (sport) => {
    if (!sport) return null;
    const sportData = sportsData[sport];
    return sportData?.sport || sport.toLowerCase();
};

// Helper function to get markets for a specific sport
export const getMarkets = (sport, type = 'all') => {
    if (!sport) return [];
    const sportData = sportsData[sport];
    if (!sportData || !sportData.markets) return [];
    
    if (type === 'game') return sportData.markets.game || [];
    if (type === 'player') return sportData.markets.player || [];
    return [...(sportData.markets.game || []), ...(sportData.markets.player || [])];
};

// Helper function to get outcomes (legacy - kept for compatibility)
export const getOutcomes = (sport) => {
    return getMarkets(sport, 'all');
};

export default sportsData;
